<template>
  <div class="solve-problem">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">成为云企业，我们帮您解决难题</div>
      </div>
      <div class="module-body">
        <div class="content-item zzbg">
          <div class="content-item-title">
            <span>资质不够？</span>
            <span class="text-primary">平台现成资质直接用</span>
          </div>
          <div class="content-item-text">平台持有电子与智能化工程一级、安防工程一级等 10 余项高等级资质，入驻企业可直接用于项目投标，无需自行投入时间与资金申请</div>
        </div>
        <div class="content-item qrqzy">
          <div class="content-item-title">
            <span>缺人缺资源？</span>
            <span class="text-primary">随用随取不浪费</span>
          </div>
          <div class="content-item-text">整合 1000 + 优质供应商（含华为、海康威视等战略合作伙伴）及数十个专业服务团队，企业可按项目需求派遣工单，减少固定投入</div>
        </div>
        <div class="content-item zjjz">
          <div class="content-item-title">
            <span>资金紧张？</span>
            <span class="text-primary">平台帮你扛垫资</span>
          </div>
          <div class="content-item-text">平台提供资金支持，平台管家协助您完成申请和审核流程；提供代采购服务，可延长账期缓解流动资金压力</div>
        </div>
        <div class="content-item mhxm">
          <div class="content-item-title">
            <span>没好项目？</span>
            <span class="text-primary">平台整合资源任你选</span>
          </div>
          <div class="content-item-text">平台整合全国最新招标信息供实时查看，同步提供海量行业解决方案，帮助企业突破项目类型限制，承接更多领域业务</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.solve-problem {
  padding: 64px 0;

  .content-center {
    .module-body {
      height: 566px;
      margin-top: 54px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;
      .content-item {
        width: 624px;
        height: 254px;
        padding: 40px 32px;
        border-radius: 8px;
        background-color: #fff;
        background-position: right bottom;
        background-repeat: no-repeat;
        .content-item-title {
          font-family: @font-medium;
          font-size: 18px;
        }
        .content-item-text {
          width: 420px;
          margin-top: 18px;
          color: #666;
          line-height: 30px;
          text-align: justify;
        }
        &.zzbg {
          background-image: url('@/assets/img/cooperation/SolveProblem/item_bg_zzbg.png');
        }
        &.qrqzy {
          background-image: url('@/assets/img/cooperation/SolveProblem/item_bg_qrqzy.png');
        }
        &.zjjz {
          background-image: url('@/assets/img/cooperation/SolveProblem/item_bg_zjjz.png');
        }
        &.mhxm {
          background-image: url('@/assets/img/cooperation/SolveProblem/item_bg_mhxm.png');
        }
      }
    }
  }
}
</style>
